import { SIGNUP } from "../configs/routes";
import api from "./api";

export const signup = (user) =>
    new Promise((resolve, reject) => {
        const isLoggingIn = true;
        api
            .post(SIGNUP, user, isLoggingIn)
            .then((response) => resolve(response.data))
            .catch((err) => reject(err?.response?.data?.message || "Signup failed, please try again"));

    });
